export default __webpack_public_path__ + "static/media/WONE.ba412416.svg";